module.exports = __webpack_public_path__ + "img/MDI-calendar-check-participation.a768bdc0.svg";